import { FC } from 'react';
// i18next
import { useTranslation } from 'react-i18next';
// Redux
import { useAppSelector } from 'hooks/useStore';
import { selectResult } from 'store/player/playerSelectors';
import { selectQuiz } from 'store/quiz/quizSelectors';
import IQuiz from 'models/Quiz';

import classes from './styles.module.css';
import useCompactLayout from 'hooks/useCompactLayout';

const Prizes:FC = () => {
  const { t } = useTranslation();
  const isCompact = useCompactLayout();

  const result:any = useAppSelector(selectResult);
  const storeQuiz = useAppSelector(selectQuiz);
  const quiz:IQuiz | null = storeQuiz || result?.quiz || null;
  const prizes:string[] = quiz?.prizes || result?.quizGroup?.prizes || [];
  const spotPrizes = quiz?.spotPrizesEnabled ? quiz?.spotPrizes || [] : [];

  const hidePrizes = !prizes.length && !spotPrizes.length;
  if (hidePrizes) return null;

  const visiblePrizes = [...prizes, ...spotPrizes];

  return (
    <div
      className={`relative overflow-hidden shrink-0 rounded-3xl w-full shadow-primary-border ${isCompact ? 'mb-2 p-5' : 'mb-4 p-4 xl:mb-0'}`}
      style={{
        backgroundColor: quiz?.publicLeaderboard?.backgroundColor ?? result?.quizGroup?.publicLeaderboard?.backgroundColor ?? 'rgba(0,0,0,0.6)',
      }}
    >
      <h2
        className={`text-center font-extrabold italic uppercase ${classes.prizesTitle} ${isCompact ? 'mb-3' : 'mb-4'}`}
        style={{ color: quiz?.publicLeaderboard.primaryColor }}
      >
        {t('labels.youCouldWin')}
      </h2>
      {visiblePrizes.map((prize) => (
        <p key={prize} className={`text-center uppercase last:mb-0 ${classes.prizeItem} ${isCompact ? 'mb-2 truncate' : 'mb-2'}`}>{prize}</p>
      ))}
    </div>
  )
}

export default Prizes;
